import { getFirstErrorKey } from "./getFirstErrorKey";

export const focusElement = (errors) => {
  let element = null;
  const firstErrorKey = getFirstErrorKey(errors);

  if (global.window.document.getElementsByName(firstErrorKey).length) {
    element = global.window.document.getElementsByName(firstErrorKey)[0];
    if (element instanceof HTMLInputElement && element.type !== 'checkbox' && element.type !== 'radio' ) {
      element.focus();
    } else {
      global.window.document.querySelector('.accordion-header.hasErrors')?.scrollIntoView();
    }
  } else {
    global.window.document.querySelector('.accordion-header.hasErrors')?.scrollIntoView();
  }
};